<form>
  <mat-form-field
    class="example-chip-list"
    appearance="outline"
    class="tw-w-full"
  >
    <mat-label>{{ input_title | translate }}</mat-label>
    <mat-chip-grid #chipList>
      <mat-chip-row *ngFor="let item of items" (removed)="remove(item)">
        {{ item }}
        <button matChipRemove>
          <mat-icon class="dark:tw-text-gray-400">cancel</mat-icon>
        </button>
      </mat-chip-row>
      <input
        matInput
        [placeholder]="input_placeholder | translate"
        #chipInput
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
        (blur)="checkInputWhenBlur()"
        (paste)="checkPastedText($event)"
      />
    </mat-chip-grid>
  </mat-form-field>
</form>
